// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9r-0";
export var optionCard = "_9r-1";